import { UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

// Custom validator to check that two fields do not match
export const mustNotMatchValidator = (controlName: string, matchingControlName: string) => {
  return (formGroup: UntypedFormGroup): ValidatorFn => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    // If controls don't exist or haven't been touched/filled, return null
    // This prevents errors from appearing prematurely
    if (!control || !matchingControl || !control.value || !matchingControl.value) {
      return null;
    }

    let currentErrors: ValidationErrors | null = matchingControl.errors;

    if (control.value === matchingControl.value) {
      // Merge with existing errors to preserve them
      matchingControl.setErrors({
        ...(currentErrors || {}),
        mustNotMatch: true,
      });
    } else {
      if (currentErrors && currentErrors['mustNotMatch']) {
        const { mustNotMatch, ...otherErrors } = currentErrors;
        if (Object.keys(otherErrors).length > 0) {
          matchingControl.setErrors(otherErrors); // Set back other errors if they exist
        } else {
          matchingControl.setErrors(null);
        }
      }
    }

    return null;
  };
};
